import script from "./bridgingGapSection.vue?vue&type=script&setup=true&lang=js"
export * from "./bridgingGapSection.vue?vue&type=script&setup=true&lang=js"

import "./bridgingGapSection.vue?vue&type=style&index=0&id=71da33ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71da33ec"]])

export default __exports__